import { Outlet, useParams } from "react-router-dom";
import TramiteProvider from "../context/Tramite";

function TramitePageLayout({ children, ...props }) {
  return <>{children}</>;
}

export default function TramitePage({ ...props }) {
  const { numero } = useParams();
  return (
    <TramiteProvider numero={numero}>
      <TramitePageLayout>
        <Outlet />
      </TramitePageLayout>
    </TramiteProvider>
  );
}
